import textureUrls from './textures/urls'

export default {
  camera: {
    position: {
      x: 0,
      y: 0,
      z: 0,
    },
  },
  game: {
    bricksKnocked: 0,
    bricksBefore: 0,
    level: 0,
    levelRound: 0,
    numRounds: 3,
    score: 0,
    textureUrl: textureUrls.pikachu,
  },
  objects: {
    ball: {
      mass: 5,
      radius: 0.6,
    },
    base: {
      arm: {
        movement: 0,
        rotationSpeed: 20,
      },
    },
    rope: {
      length: 3,
      mass: 3,
      segments: 10,
    },
    wall: {
      brick: {
        mass: 0.5,
        length: 2,
        depth: 2,
      },
      height: 6,
      width: 6,
    },
  },
  physics: {
    gravity: {
      constant: -9.8,
    },
    margin: 0.5,
  },
}
